<template>
    <div class="page-content">
        <PageHeader title="屏蔽规则管理">
        </PageHeader>
        <div class="page-scroll-box">
            <div>
                <el-button type="primary" icon="el-icon-plus" style="margin:0 0 20px 30px" @click="handleAddClick">
                    新建屏蔽规则
                </el-button>
            </div>
            <div class="list-data">
                <ShowTable
                    :listData="listData"
                    :pageShow="true"
                    :pageSize="params.page_size"
                    @actionClick="handleClick"
                    @pageChange="pageChangeHandle"
                    @pageSizeChange="pageSizeChangeHandle"
                />
            </div>
        </div>
        <el-dialog :title="`${!currentRow ? '新建' : '编辑'}屏蔽规则`" :visible.sync="dialogFormVisible" width="650px"
                   :close-on-click-modal="false">
            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item label="屏蔽规则名称" :label-width="formLabelWidth" prop="shield_name">
                    <el-input v-model="form.shield_name"></el-input>
                </el-form-item>
                
                <el-form-item label="应用名称" :label-width="formLabelWidth" prop="media_id">
                    <el-select v-model="form.media_id" placeholder="请选择应用" filterable :disabled="!!currentRow">
                        <el-option v-for="item in appOptions" :key="item.id" :label="item.name"
                                   :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item label="媒体黑名单" :label-width="formLabelWidth" prop="blacklist">
                    <TagInput v-model="form.blacklist" width="100%" placeholder="输入包名, 多个逗号分隔, 回车添加"
                              :maxLength="maxLength" validate-type="package"/>
                    <div class="tooltips">最多{{ maxLength }}个，已添加{{ form.blacklist.length }}个</div>
                </el-form-item>
                
                <el-form-item label="关键词屏蔽" :label-width="formLabelWidth" prop="keyword">
                    <TagInput v-model="form.keyword" width="100%" placeholder="输入关键词, 多个逗号分隔, 回车添加"
                              :maxLength="maxLength" validate-type="keyword"/>
                    <div class="tooltips">最多{{ maxLength }}个，已添加{{ form.keyword.length }}个</div>
                </el-form-item>
            
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleAddShield">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import ShowTable from '@/components/ShowTable'
import TagInput from '@/components/Form/TagInput'
import {getAppList} from '@/apis/flow.js';
//
import {getShieldList, getShieldInfo, doEditShield, doAddShield, doDeleteShield} from '@/apis/advCenter.js';

export default {
    components: {
        PageHeader,
        ShowTable,
        TagInput
    },
    data() {
        return {
            maxLength: 500,
            params: {
                page: 1,
                page_size: 10,
            },
            currentRow: {},
            appOptions: [],
            listData: {
                head: [
                    {
                        key: 'shield_name',
                        name: '屏蔽规则',
                        align: 'center',
                    },
                    {
                        key: 'dimension',
                        name: '屏蔽维度',
                        align: 'center',
                    },
                    {
                        key: 'media_name',
                        name: '应用名称',
                        align: 'center',
                    },
                    {
                        key: 'create_time',
                        name: '创建时间',
                        align: 'center',
                    },
                    {
                        key: 'action',
                        name: '操作',
                        type: 'action',
                        align: 'center',
                        actionList: [
                            {
                                key: 'edit',
                                name: '修改'
                            },
                            {
                                key: 'delete',
                                name: '删除'
                            }
                        ]
                    },
                ],
                list: [],
                currentPage: 1,
                total: 3,
            },
            dialogFormVisible: false,
            form: {
                shield_name: '',
                media_id: '',
                blacklist: [],
                keyword: []
            },
            formLabelWidth: '110px',
            rules: {
                shield_name: [
                    {required: true, message: '请输入屏蔽规则名称', trigger: 'blur'},
                    {max: 30, message: '长度在30个字符以内', trigger: 'blur'}
                ],
                media_id: [
                    {required: true, message: '请选择应用名称', trigger: 'change'}
                ],
            }
        }
    },
    created() {
        this.getAppList()
        this.getList()
    },
    methods: {
        async getAppList() {
            const userInfo = this.$ls.get('userInfo');
            if ((userInfo && userInfo.main_user) || userInfo.account_status !== 1) return;
            
            const {data = {}} = await getAppList({
                is_qtt_union: 1,
                status: 0,
                page: 1,
                page_size: 999
            })
            this.appOptions = data.list || []
        },
        async getList() {
            const {data = {}} = await getShieldList(this.params);
            console.log(data)
            this.$set(this.listData, 'list', data.list)
            this.$set(this.listData, 'total', data.total)
            this.listData.list.forEach(item => {
                const dimension = []
                if (item.blacklist) {
                    dimension.push('媒体黑名单')
                }
                if (item.keyword) {
                    dimension.push('关键词屏蔽')
                }
                item.dimension = dimension.join('&')
            });
            console.log('this.listData', this.listData)
            this.$set(this.listData, 'currentPage', this.params.page)
        },
        handleAddClick() {
            this.currentRow = null
            this.form.shield_name = ''
            this.form.media_id = ''
            this.form.keyword = []
            this.form.blacklist = []
            this.form.version = 0;
            this.dialogFormVisible = true
        },
        
        handleAddShield() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    let params = {
                        shield_name: this.form.shield_name,
                        media_id: this.form.media_id,
                        blacklist: this.form.blacklist.join(','),
                        keyword: this.form.keyword.join(','),
                        version: this.form.version
                    }
                    if (this.currentRow) {
                        params.id = this.currentRow.id
                        await doEditShield(params)
                    } else {
                        await doAddShield(params)
                    }
                    this.getList()
                    this.dialogFormVisible = false
                }
            });
        },
        async handleEditClick(row) {
            const res = await getShieldInfo({media_id: row.media_id});
            let detail = res && res.data;
            this.currentRow = detail
            const {keyword, blacklist} = detail
            this.form.shield_name = detail.shield_name
            this.form.media_id = detail.media_id
            this.form.keyword = keyword ? keyword.split(',') : []
            this.form.blacklist = blacklist ? blacklist.split(',') : []
            this.form.version = detail.version || 0
            this.dialogFormVisible = true
        },
        handleClick(btn, row) {
            const key = btn.key;
            console.log(key, row)
            switch (key) {
                case 'edit':
                    this.handleEditClick(row)
                    break;
                case 'delete':
                    this.handleDeleteClick(row)
                    break;
                default:
                    break;
            }
        },
        handleDeleteClick(row) {
            this.$confirm('此操作将永久删除该屏蔽规则, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                //发送删除请求
                await doDeleteShield({
                    id: row.id,
                    media_id: row.media_id,
                    version: row.version || 0
                })
                this.getList()
            }).catch(() => {
                // this.$message({
                //   type: 'info',
                //   message: '已取消删除'
                // });
            });
        },
        pageChangeHandle(page) {
            this.params.page = page
            this.getList()
        },
        pageSizeChangeHandle(pageSize) {
            this.params.page = 1
            this.params.page_size = pageSize
            this.getList()
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/page.scss";

.page-content {
    height: 100%;
    overflow: hidden;
    
    .page-scroll-box {
        height: calc(100% - 72px);
        padding: 24px 32px 32px;
        box-sizing: border-box;
        overflow: scroll;
    }
}

.tooltips {
    color: #adaaaa;
    font-style: normal;
    line-height: 20px;
}
</style>